<template>
  <!-- 站点信息 -->
  <div>
      <w-table
        v-if="typeName"
        v-loading.body="tableLoading"
        :data-list="companyData"
        :columns="staticData[typeName].columns"
        :pageNo="formData.pageNum"
        :pageSize="formData.pageSize"
        :total="total"
        @pageNoChange="pageNoChange"
        @pageSizeChange="pageSizeChange"
        >
        <template slot-scope="props" slot="cell">
          <span v-if="props.column.label === '序号'">{{ props.index + 1 + (formData.pageNum - 1) * formData.pageSize}}</span>
          <span v-else-if="props.column.label === '站点编号'">
            <span class="cursor text-decoration" @click="jjSearch(props.row)">{{props.row.siteId}}</span>
          </span>
          <span v-else-if="props.column.label === '站点名称'">
            <span class="cursor text-decoration" @click="jjSearch(props.row)">{{props.row.siteName}}</span>
          </span>
          <span v-else-if="props.column.label === '站点车辆'">
            <span class="cursor blue" @click="onShowDialog2(props.row)">{{props.row.num}}</span>
          </span>
          <span v-else-if="props.column.label === '操作'">
            <el-button size="small" type="primary">编辑</el-button>
          </span>
        <span v-else>{{ props.row[props.column.property]}}</span>
        </template>
      </w-table>
    </div>
</template>

<script>
import WTable from '@/components/Table/index.vue'
import staticData from './staticData.js'
import Api from '@/api'
import { mapGetters } from 'vuex'

export default {
  components: {
    WTable
  },
  props: ['typeName','currentData'],
  data() {
    return {
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      tableLoading: false,
      tableData: null,
      companyData: []
    }
  },
  computed: {
    ...mapGetters(['selfAreaId']),
    staticData() {
      return staticData
    }
  },
  created() {
    this.initData()
  },
  methods: {
    jjSearch(item) {
      this.$emit('jjSearch', item)
    },
    initData() {
      const vm = this
      vm.tableLoading = true
      const params = {
        selfAreaId: vm.selfAreaId,
        brandId: vm.currentData.brandId,
        bikeType: vm.currentData.bikeType,
        currentPage: vm.formData.pageNum,
        pageSize: vm.formData.pageSize
      }
      Api.getBrandOnlineBike(params)
        .then(res => {
          if (res.code === 200) {
            vm.companyData = res.data.lists
            vm.total = res.data.total
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
    },
    onShowDialog2(item) {
      const data = {
        ...item,
        type: 'bikes',
        bikeType: this.currentData.bikeType
      }
      this.$emit('onShowDialog2', data)
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.initData()
    },
    pageSizeChange(size) {
      this.formData.pageSize = size
      this.initData()
    },
  }
}
</script>
